import React, { useEffect, useState } from 'react'
import { func, number, oneOfType, string } from 'prop-types'
import TabList from '@taglivros/oef_componentes/build/components/tabList'
import { METODOS_PAGAMENTO, METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX } from '../../../constants'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { ETAPA_PAGAMENTO } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { deixaPrimeiraLetraStringMaiusculo } from '../../../containers/Modalidade/Plano/CancelarAssinatura/MotivosCancelamento/constantsMotivosCancelamento'

const EscolhaMetodoPagamento = ( { metodoPagamentoSelecionado, setMetodoPagamentoSelecionado } ) => {
  const [ visualizacaoMetodosPagamento, setVisualizacaoMetodosPagamento ] = useState( [] )
  const [ componenteMontando, setComponenteMontando ] = useState( true )
  const { dadosEtapas, temaFluxo } = useFluxosPagamento()

  useEffect( () => {
    const visualizacao = Object.entries( METODOS_PAGAMENTO ).map( metodo => {
      const [ nomeDoMedoto, objetoMetodo ] = metodo
      return ( {
        'codigo': objetoMetodo.id,
        'visualizacao': deixaPrimeiraLetraStringMaiusculo( objetoMetodo.visualizacao.toLocaleLowerCase() )
      } )
    } )

    setVisualizacaoMetodosPagamento( visualizacao )
    setComponenteMontando( false )
  }, [] )

  useEffect( () => {
    if ( !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) ) {
      const hasMetodoPagamento = Object.prototype.hasOwnProperty.call( dadosEtapas[ ETAPA_PAGAMENTO ], 'metodoPagamento' )
      const isCartao = hasMetodoPagamento && dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento === METODO_PAGAMENTO_CARTAO.slug
      const isPix = hasMetodoPagamento && dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento === METODO_PAGAMENTO_PIX.slug
      if ( hasMetodoPagamento ) {
        if ( isCartao ) {
          setMetodoPagamentoSelecionado( METODO_PAGAMENTO_CARTAO.id )
        } else if ( isPix ) {
          setMetodoPagamentoSelecionado( METODO_PAGAMENTO_PIX.id )
        }
      }
    } else if ( isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) && componenteMontando ) {
      setMetodoPagamentoSelecionado( METODO_PAGAMENTO_CARTAO.id )
    }
  }, [ dadosEtapas ] )

  return (
    <div>
      <TabList
        ativo={ metodoPagamentoSelecionado }
        itens={ visualizacaoMetodosPagamento }
        onClick={ codigo => setMetodoPagamentoSelecionado( codigo ) }
        optionalColor={ temaFluxo }
      />
    </div>
  )
}

EscolhaMetodoPagamento.defaultProps = {
  'metodoPagamentoSelecionado': null
}

EscolhaMetodoPagamento.propTypes = {
  'metodoPagamentoSelecionado': oneOfType( [ number, string ] ),
  'setMetodoPagamentoSelecionado': func.isRequired
}

export default EscolhaMetodoPagamento
